import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setMobileHomeLength } from '../../redux/modules/titlefees';
import getPipeValue from '../../modules/getPipeValue';
import Dropdown from '../../components/Dropdown';

class TitleTotalMobileHomeFee extends Component {
  constructor(props) {
    super(props);
    this.onLengthSelect = this.onLengthSelect.bind(this);
  }

  onLengthSelect(event) {
    if (this.shouldShow()) {
      this.props.setMobileHomeLength(event.target.value);
    }
  }

  shouldShow() {
    const { selectedVehicleValue } = this.props;
    const { t2, mcoTitle, floridaTitle, osTitle } = this.props.selectedTitleVariables;
    let r16 = 0;
    if (selectedVehicleValue) {
      r16 = Number(getPipeValue(selectedVehicleValue, 'r16'));
    }

    let show = false;
    if (selectedVehicleValue && selectedVehicleValue.search('MOBILE HOME') > -1) {
      show = true;
    }

    if (floridaTitle || mcoTitle || osTitle) {
      if (r16 === t2 || r16 === 0 || t2 === 8) {
        if (t2 === 4) {
          show = true;
        }
      }
    }
    return show;
  }

  getLengthText() {
    const lengths = ['Single-wide (x1)', 'Double-wide (x2)', 'Triple-wide (x3)'];
    return lengths[this.props.mobileHomeLength - 1];
  }

  render() {
    const { mobileHomeLength } = this.props;
    const options = [
      ['Single-wide Mobile Home', 1],
      ['Double-Wide Mobile Home (double fees)', 2],
      ['Triple-wide Mobile Home (triple fees)', 3],
    ];

    return (
      <div className="Row Title-mobileHomeRow" style={{ display: this.shouldShow() ? 'block' : 'none' }}>

        <input
          className="Row-total Row-totalText"
          value={this.getLengthText() || ''}
          readOnly
          tabIndex="-1"
        />

        <Dropdown
          id="titleMobileHomeLength"
          options={options}
          tooltip="Select the length of the Mobile Home"
          onChange={this.onLengthSelect}
          selectedValue={mobileHomeLength || 1}
          className="Dropdown Row-dropdown no-print"
        />
        <b className="print-only">Mobile home length</b>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    mobileHomeLength: state.registration.mobileHomeLength,
    titleType: state.titlefees.titleType,
    showMobileHomeRow: state.titlefees.showMobileHomeRow,
    selectedVehicleValue: state.titlefees.selectedVehicleValue,
    selectedTitleVariables: state.titlefees.selectedTitleVariables,
  };
};

export default connect(mapStateToProps, { setMobileHomeLength })(TitleTotalMobileHomeFee);
